export default __webpack_public_path__ + "static/media/group-6087.a787e9d8.svg";